import { color, EChartsOption } from "echarts";
import { CustomSeriesOption, graphic } from "echarts";


export const chartWidth = 50;
export const chartHeight = 240;

function mapValue(value: number) {
  // value 是 0 到 0.5 换算为 -2 到 98
  return 200 * value - 3;
}

// 根据value值确定颜色的函数
function getColorBasedOnValue(value: number) {
  let Gradient = [];
  if (value <= 3000) {
    return "rgba(128, 128, 128, 1)";
  } else if (value > 3000 && value <= 8000) {
    Gradient.push(
      {
        offset: 0,
        color: "rgba(66, 192, 144, 1)",
      },
      {
        offset: 1,
        color: "rgba(128, 128, 128, 1) ",
      }
    );
    return new graphic.LinearGradient(0, 0, 0, 1, Gradient);
  } else if (value > 8000 && value <= 10000) {
    Gradient.push(
      {
        offset: 0,
        color: "rgba(207, 19, 34,1)",
      },
      {
        offset: 0.1,
        color: "rgba(66, 192, 144, 1)",
      },
      {
        offset: 1,
        color: "rgba(128, 128, 128, 1)",
      }
    );
    return new graphic.LinearGradient(0, 0, 0, 1, Gradient);
  } else if (value > 10000) {
    Gradient.push(
      {
        offset: 0,
        color: "rgba(207, 19, 34, 1)",
      },
      {
        offset: 0.6,
        color: "rgba(66, 192, 144, 1)",
      },
      {
        offset: 1,
        color: "rgba(128, 128, 128, 1)",
      }
    );
    return new graphic.LinearGradient(0, 0, 0, 1, Gradient);
  }
}

// 定义条形图的公共配置
const commonSeriesConfig = {
  barWidth: 100, // 条形图的宽度
  stack: "progress", // 条形图堆叠
  itemStyle: {
    borderColor: "#fff", // 边框颜色
    borderWidth: 2, // 边框宽度
    height: 1000, // 条形图的高度
  },
};
var PatternSrc =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAACyAgMAAAC8Zj5WAAAADFBMVEU1mcQAAAA1mcQ1mcQFya0nAAAABHRSTlMZAAkRJfDlNAAAAFtJREFUOMtjCIWBEAYyAcIEkpikgDMGh3nAyIAkK1bBwAqSbPsPA39Ism03DOwgyTaEI0myDeFIWtk2NJIGfW07bwwFNvRIiIgUNZoQB33SQIBBXEaNJsQhmRABdkqh2Grn4rYAAAAASUVORK5CYII=";
var PatternImg = new Image();
PatternImg.src = PatternSrc;
PatternImg.style.bottom  = '0px'
var fillSrc =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAF+CAMAAADz+WkdAAAAY1BMVEUAAAA00Lw92bE41LdD36lJ5aJV8JRb9Y1N6Z1R7ZhY85BZ9I8207kyz75b9o000bw51bZX8pJV8JRA3K1N6Z1Q7JlL56BT7pdC3qs717NE4Kg82LI+2rBG4aZI46RJ5aJP6pvNrsJWAAAAC3RSTlMA5+fn5+fn5+fn5wyCdZUAAAFNSURBVHja7dLrboJQEEXhkZuKqK2giNe+/1O2L9BkVtJjD+P++L1CBrYtd4ztAgT4aHHQlrSlP7PcMLYJEOCjxaPN70+nD1pt6cf/b+kTyjFoaSAeTX5/On3QaEspNAfGDgECfLRksqWRPS94QzMyJh7rkbExQLDWllJYHxk7Bgjw0TLTLX1BPFjRQDxWA2NDgAAfLTPd0gmy08AeW9E3RFDjzxogqN/xT6dXPxl7Bgjw0eJRPxh7BAjw0eJR3xm7BwgqGohHdWHsEiDAR0uSLZ2hHIOKBuJRJf9xPWTnnj38DRUNxKPoGesDBIW2lEJxY+wWIMBHi0dxZewaIMBHi0cxMTYFCPDR4lFOjH1AOQYlDcSjzO9Pa0szVXaMdQECfLRoS78EC20phcWesT0OOvYYfwPEj5ZMtpRfoC0lsdgytg0Q4KNFW9KWXugb9rK+ibjhjhMAAAAASUVORK5CYII=";
var fillImg = new Image();
fillImg.src = fillSrc;

// 获取图表的默认配置
export const getChartsDefaultOptions = (value: number) => {
  // const option = {
  //   animation: false,
  //   backgroundColor: "rgba(0,0,0,0)", // 背景颜色设置为透明
  //   grid: {
  //     show: false, // 是否显示网格
  //     zlevel: 0, // 网格的层级
  //     z: 2, // 网格的 z 值
  //     left: 20, // 网格距离左侧的距离
  //     top: 0, // 网格距离顶部的距离
  //     right: 20, // 网格距离右侧的距离
  //     bottom: 0, // 网格距离底部的距离
  //     width: "auto", // 网格的宽度
  //     height: "auto", // 网格的高度
  //   },
  //   yAxis: {
  //     type: "category",
  //     data: ["progress", "test"],
  //     axisLabel: {
  //       show: false, // 是否显示标签
  //       inside: false, // 标签是否朝内
  //       textStyle: {
  //         color: "#fff", // 标签文字颜色
  //       },
  //     },
  //     axisTick: {
  //       show: false, // 是否显示刻度线
  //     },
  //     axisLine: {
  //       show: false, // 是否显示轴线
  //     },
  //     splitLine: {
  //       show: false, // 是否显示分割线
  //     },
  //     z: 10, // X 轴的 z 值
  //   },
  //   xAxis: {
  //     type: "value",
  //     axisLabel: {
  //       show: false,
  //       inside: false,
  //       textStyle: {
  //         color: "#fff",
  //       },
  //     },
  //     max: 10, // Y 轴最大值
  //     axisTick: {
  //       show: false,
  //     },
  //     axisLine: {
  //       show: false,
  //     },
  //     splitLine: {
  //       show: false,
  //     },
  //     z: 10,
  //   },
  //   series: [
  //     // {
  //     //   name: "制动强度校验", // 系列名称
  //     //   type: "line", // 系列类型为折线图
  //     //   symbol: "rect", // 折线图的标记类型
  //     //   symbolSize: [100, 5], // 标记大小
  //     //   itemStyle: commonLineStyle, // 折线图的样式
  //     //   data: [value],
  //     // },
  //     // 生成 1-3 的条形图系列
  //     ...["#cfd8dc", "#b0bec5", "#90a4ae", "#607d8b", "#455a64"].map(
  //       (color) => ({
  //         name: `${color}`, // 系列名称
  //         type: "bar", // 系列类型为条形图
  //         ...commonSeriesConfig, // 应用公共配置
  //         itemStyle: {
  //           ...commonSeriesConfig.itemStyle,
  //           color: color, // 条形图的颜色
  //           // borderColor: "#fff",
  //           // shadowBlur: 200, // 阴影的模糊程度
  //           // shadowColor: "rgba(255, 255, 255, 0.6)", // 阴影颜色
  //           // shadowOffsetX: 0, // 阴影在X轴上的偏移量
  //           // shadowOffsetY: 0, // 阴影在Y轴上的偏移量
  //         },
  //         data: [2], // 数据
  //         z: 2,
  //       })
  //     ),
  //     {
  //       type: "bar",
  //       name: "test",
  //       barGap: "-100%",
  //       // stack: "progress",
  //       // ...commonSeriesConfig, // 应用公共配置
  //       // showBackground: true,
  //       position: "top",
  //       barWidth: 100,
  //       backgroundStyle: {
  //         color: "rgba(220, 220, 220, 0.9)",
  //         // barBorderRadius: [30, 30, 30, 30] //圆角大小
  //       },
  //       label: {
  //         show: true,
  //         position: [mapValue(value) + "%", -25], //每一条的数据位置
  //         formatter: (params) => {
  //           return "▼";
  //         },
  //         color: "#4caf50",
  //         fontSize: 30,
  //         // rotate: 90,
  //       },
  //       itemStyle: {
  //         // color: "#ff00ff",
  //         color: "rgba(0,0,0,.0)", //每个数据的颜色
  //         // shadowBlur: 10,
  //         // shadowColor: "rgba(0, 103, 255, 0.2)",
  //         // shadowOffsetX: -5,
  //         // shadowOffsetY: 5,
  //       },
  //       data: [10],
  //       z: 1,
  //     },
  //     // 生成 4-6 的条形图系列
  //     // ...[3, 4, 5, 6].map((i) => ({
  //     //   name: `${i}`, // 系列名称
  //     //   type: "bar", // 系列类型为条形图
  //     //   ...commonSeriesConfig, // 应用公共配置
  //     //   itemStyle: {
  //     //     ...commonSeriesConfig.itemStyle,
  //     //     color: "#1fab89", // 条形图的颜色
  //     //     borderColor: "#fff",
  //     //   },
  //     //   data: [2], // 数据
  //     // })),
  //     // ...[9, 10].map((i) => ({
  //     //   name: `${i}`, // 系列名称
  //     //   type: "bar", // 系列类型为条形图
  //     //   ...commonSeriesConfig, // 应用公共配置
  //     //   itemStyle: {
  //     //     ...commonSeriesConfig.itemStyle,
  //     //     color: "#9ba6a5", // 条形图的颜色
  //     //     borderColor: "#fff",
  //     //   },
  //     //   data: [2], // 数据
  //     // })),
  //   ],
  // } as EChartsOption;

  const max = 0.5;
  var data = [
    {
      name: "",
      value: value, // 防抖舍去两位
    },
  ];
  const maxData = [];
  var maxNumArray = [] as any;

  data.forEach(function (value, index) {
    maxNumArray.push(value.value);
  });

  data.forEach(function (value, index) {
    maxData.push({
      name: value.name,
      value: Math.max.apply(null, maxNumArray),
    });
  });

  var scale = 1;
  var option = {
    animation: false,
    backgroundColor: "rgba(0,0,0,0.0)",
    grid: {
      left: 0,
      right: 0,
      bottom: 0,
      top: 0,
      containLabel: true,
    },
    yAxis: [
      {
        type: "value",
        max,
        show: false,
        splitLine: {
          show: false,
        },
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
          inside: true,
          length: 10 * scale,
          lineStyle: {
            color: "#0b5263",
          },
        },
        axisLabel: {
          show: false,
          textStyle: {
            color: "#0b5263",
            fontSize: 14 * scale,
          },
        },
      },
    ],
    xAxis: [
      {
        type: "category",
        // data: ["sdfsdf"],
        boundaryGap: ["20%", "20%"],
        splitLine: {
          show: false,
        },
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          show: false,
          // padding: [15, 0, 0, 0],
          textStyle: {
            fontSize: 16 * scale,
            color: "#000",
          },
        },
      },
    ],
    series: [
      {
        name: "100",
        type: "bar",
        barGap: "-100%",
        // stack: "总量",
        z: 999,
        barWidth: "100%",
        data: [value],
        itemStyle: {
          color: function (params: any) {
            return { image: fillImg, repeat: "repeat" }; // 默认颜色
          },
        },
      },

      {
        name: "占位",
        type: "bar",
        barWidth: "100%",
        barGap: "-100%",
        silent: true,
        // label: {
        //   normal: {
        //     show: true,
        //     position: "top",
        //     distance: 10 * scale,
        //     formatter: function (params: any) {
        //       var stuNum = 0;
        //       data.forEach(function (value, index, array) {
        //         if (params.name == value.name) {
        //           stuNum = value.value;
        //         }
        //       });
        //       return `${stuNum}`;
        //     },
        //     textStyle: {
        //       color: "#000",
        //       fontSize: 20 * scale,
        //     },
        //   },
        // },
        itemStyle: {
          barBorderRadius: [5, 5, 0, 0],
          color: { image: PatternImg, },
        },
        data: [max],
      },
      // {
      //   name: "sdfsdf",
      //   type: "bar",
      //   barGap: "-100%",
      //   z: 99999,
      //   barWidth: 300,
      //   data: [max],
      //   itemStyle: {
      //     color: '#ff00ff',
      //   },
      // },
    ],
  }as EChartsOption;

  // const option = {
  //   animation: false,
  //   backgroundColor: "rgba(0,0,0,0.0)",
  //   grid: {
  //     top: "13%",
  //     left: "24%",
  //     right: "0%",
  //     bottom: "3%",
  //   },
  //   tooltip: {
  //     show: false,
  //   },
  //   xAxis: {
  //     data: [],
  //     axisLine: {
  //       lineStyle: {
  //         color: "transparent", //底部边框颜色
  //       },
  //     },
  //     axisLabel: {
  //       textStyle: {
  //         color: "#fff", //底部文字颜色
  //         fontSize: 12,
  //       },
  //     },
  //     splitLine: {
  //       show: false,
  //     },
  //   },
  //   yAxis: [
  //     {
  //       type: "value",
  //       max: 10,
  //       splitLine: {
  //         show: false,
  //         lineStyle: {
  //           color: "rgba(255,255,255,0.2)", //网格线的颜色
  //           width: 1,
  //           type: "solid",
  //         },
  //       },
  //       axisLine: {
  //         show: false,
  //         lineStyle: {
  //           color: "transparent", //左边框颜色
  //         },
  //       },
  //       axisLabel: {
  //         show: false,
  //         fontSize: 12,
  //         textStyle: {
  //           color: "#ADD6FF", //左文字颜色
  //         },
  //       },
  //     },
  //   ],
  //   series: [
  //     {
  //       name: "协商议题类型比例",
  //       type: "bar",
  //       barWidth: 70,
  //       showBackground: true,
  //       backgroundStyle: {
  //         color: "rgba(198, 198, 198,0.2)",
  //       },
  //       itemStyle: {
  //           color: getColorBasedOnValue(value),
  //       },
  //       data: [10],
  //       z: 0,
  //       zlevel: 0,
  //     },
  //     {
  //       type: "pictorialBar",
  //       barWidth: 70,
  //       itemStyle: {
  //         normal: {
  //           color: "rgba(198, 198, 198,0.4)", //数据的间隔颜色
  //         },
  //       },
  //       symbolRepeat: "fixed",
  //       symbolMargin: 2,
  //       symbol: "rect",
  //       symbolSize: [60, 4],
  //       symbolPosition: "end",
  //       symbolOffset: [0, 0],
  //       data: [value],
  //       z: 1,
  //       zlevel: 0,
  //     },
  //     {
  //       type: "pictorialBar",
  //       barWidth: 70,
  //       itemStyle: {
  //         normal: {
  //           color: "transparent", //数据的间隔颜色
  //         },
  //       },
  //       // symbolRepeat: 'fixed',
  //       symbolMargin: 2,
  //       symbol: "rect",
  //       symbolSize: [70, 4],
  //       data: [value],
  //       z: 1,
  //       zlevel: 0,
  //       label: {
  //         show: false,
  //         position: "top",
  //         fontSize: 14,
  //         color: "#fff", //柱状顶部文字颜色
  //         formatter: function (params) {
  //           // return '20%';
  //         },
  //       },
  //     },
  //   ],
  // } as EChartsOption;

  return option;
};
